import { render, staticRenderFns } from "./ChatMessageEdit.vue?vue&type=template&id=3ac814a6&scoped=true"
import script from "./ChatMessageEdit.vue?vue&type=script&lang=js"
export * from "./ChatMessageEdit.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageEdit.vue?vue&type=style&index=0&id=3ac814a6&prod&scoped=true&lang=css"
import style1 from "./ChatMessageEdit.vue?vue&type=style&index=1&id=3ac814a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac814a6",
  null
  
)

export default component.exports